// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Lie1","containerNewsList":"styles_containerNewsList__nsy05"};